<template>
  <div class="sceneInteractive"
       :style="{'background-image': returnBackground}">
    <iframe :src="returnUrlPath('unity/index.html')"
            class="sceneInteractive__iframe"
            v-if="hasTutorialPlayed && loadIframe"
            allowfullscreen></iframe>
    <div v-if="hasTutorialPlayed && hasBack"
         @click="goToHome"
         class="sceneInteractive__back">
      <icon-back></icon-back>
    </div>
    <transition name="slideUp">
      <scene-tutorial v-if="!hasTutorialPlayed && isInteractive"
                      @hide-tutorial="hideTutorial"></scene-tutorial>
    </transition>
  </div>
</template>

<script>
  import Spinner from './Spinner';
  import Tutorial from './InteractiveTutorial';
  import ProductListing from './interactive/ProductListing';
  import Pointer from './icons/Pointer';
  import Arrow from './icons/Arrow';

  var slider;

  export default{
    data(){
      return {
        showTutorial: true,
        productListing: [],
        hasCallSucceeded: false,
        carousel: {},
        isCarouselActive: false,
        loadIframe: false,
        hasBack: true,
        isInteractive: false
      }
    },
    components: {
      'loading-spinner': Spinner,
      'scene-tutorial': Tutorial,
      'product-listing': ProductListing,
      'icon-arrow': Arrow,
      'icon-back': Pointer
    },
    methods: {
      returnPath(path){
        return ENV.assetsRoot + path;
      },
      returnUrlPath(path){
        var url = path;
        var vm = this;

        if (vm.$route.params.product) {
          ENV.queryProduct = vm.$route.params.product;
          url = url + '?c=' + ENV.queryProduct;
        }

        return ENV.assetsRoot + url;
      },
      goToHome(){
        var vm = this;
        vm.$store.state.sceneListing.forEach(function (currentScene) {
          if (vm.$route.params.scenedetail == currentScene.slag) {
            vm.$store.state.activeSlide = vm.$store.state.sceneListing.indexOf(currentScene);
          }
        });
        var lang = vm.$route.params.lang;
        vm.$router.push('/' + lang);
      },
      hideTutorial(){
        this.showTutorial = false;
      },
      toggleCarousel(){
        this.isCarouselActive = !this.isCarouselActive;
      },
      initSlider(){
        var vm = this;
//        console.log(vm.carousel);
        if (vm.carousel.slides.length) {
          vm.$nextTick()
            .then(function () {
              slider = tns({
                container: document.querySelector('.sceneCarousel__slider'),
                items: 1,
                slideBy: 1,
                controls: true,
                controlsContainer: document.querySelector('.sceneCarousel__controls'),
                prevButton: '.btn--prev',
                nextButton: '.btn--next',
                nav: true,
                navContainer: document.querySelector('.sceneCarousel__nav'),
                autoplay: false,
                loop: true,
                arrowKeys: true,
                speed: 600
              })
            });

        }

      },
      fetchCatalogueData(){
        var vm = this;
        var catalogueUrl = document.querySelector('#root').getAttribute('data-endpoint-catalogue');
        if (!catalogueUrl) {
          catalogueUrl = 'http://ig-dle.hosting.dgtmedia.com/assets/ajax/PHOTOMETRIC_ID';
          catalogueUrl = catalogueUrl.replace('PHOTOMETRIC_ID', vm.$route.params.photometric);
          catalogueUrl = catalogueUrl + '.json';
        }
        else {
          catalogueUrl = catalogueUrl.replace('PHOTOMETRIC_ID', vm.$route.params.photometric);
          ENV.interactive = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');
          if (ENV.debugMode) {
            catalogueUrl = catalogueUrl + '.json';
          }
        }
        console.log(catalogueUrl);
        fetch(catalogueUrl, {})
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function (data) {
            if (data.header.success) {
              var res = data.data;
              ENV.unityBaseUrl = res.base_url;
              ENV.currentScene = res.build_folder;
              ENV.currentSceneID = res.scene_slug;
              ENV.isCatalogue = true;
              ENV.catalogueConfig = {};
              ENV.interactive = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');
              ENV.catalogueConfig.chromacity = res.chromacity;
              ENV.catalogueConfig.optic = res.optic;
              ENV.catalogueConfig.photometric = res.photometric_id;
              ENV.closeUpId = res.int;
              if (typeof ENV.currentSceneID == 'undefined') {
                vm.goToHome();
              }
              vm.$store.state.interface.isVisible = false;
              vm.$store.state.interface.isFooterVisible = false;
              vm.$store.state.hasApplicationLoaded = true;
              vm.hasBack = false;
              vm.showTutorial = false;
              console.log('Loading Unity');
              vm.$store.state.hasTutorialPlayed = true;
              vm.loadIframe = true;
              document.querySelector('.sceneInteractive__iframe').classList.add('no-padding');
            }
          })
      },
      fetchInteractiveData(){
        var vm = this;
        vm.loadIframe = true;
        vm.isInteractive = true;

        ENV.currentScene = vm.$route.params.scenedetail;

        //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));
        var listingUrl = document.querySelector('#root').getAttribute('data-endpoint-listing');

        //Check if store listing is already populated
        //If it is, use it to build carousel
        var sceneListing = this.$store.state.sceneListing;
        var currentScene;
        if (sceneListing.length) {
          for (var i = 0; i < sceneListing.length; i++) {
            var currentObj = sceneListing[i];
            if (currentObj.slag == vm.$route.params.scenedetail) {
              currentScene = currentObj;
              ENV.currentSceneID = currentObj.sceneId;
            }
          }
          if (typeof ENV.currentSceneID == 'undefined') {
            vm.goToHome();
          }
          ENV.interactive = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');
          vm.carousel = currentScene.interactive;
          vm.$store.state.hasApplicationLoaded = true;
          vm.initSlider();
        }
        //Else make call to retrieve initialization info and store it in application store
        else {
          fetch(listingUrl, {
            //credentials: "include"//,
            //headers: myHeaders
          })
            .then(function (response) {
              return response.json();
            })
            .catch(function () {
              vm.$router.push('/');
            })
            .then(function (data) {
              if (data.header.success) {
                vm.$store.state.sceneListing = data.data;
                sceneListing = data.data;
                for (var i = 0; i < sceneListing.length; i++) {
                  var currentObj = sceneListing[i];
                  if (currentObj.slag == vm.$route.params.scenedetail) {
                    currentScene = currentObj;
                    ENV.currentSceneID = currentObj.sceneId;
                  }
                }
                if (typeof ENV.currentSceneID == 'undefined') {
                  vm.goToHome();
                }
                ENV.interactive = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');
                vm.carousel = currentScene.interactive;
                vm.$store.state.hasApplicationLoaded = true;
                vm.initSlider();
              }
              else {
                vm.$router.push('/');
              }
            });
        }

        eventTracking.send({
          category: 'Interactive',
          action: 'View',
          label: vm.$route.params.scenedetail
        });
      }
    },
    computed: {
      returnBackground(){
        var vm = this;
        var path = 'assets/img/tutorial-background.jpg';
        if (vm.loadIframe) {
          return 'url(' + ENV.assetsRoot + path + ')';
        }
        else{
          return 'none'
        }
      },
      hasTutorialPlayed(){
        return this.$store.state.hasTutorialPlayed;
      }
    },
    updated(){
      var vm = this;
      ENV.currentScene = vm.$route.params.scenedetail;
      if (vm.$route.params.photometric) {
        vm.fetchCatalogueData();
      }
      else {
        vm.fetchInteractiveData();
      }
    },
    mounted(){
      var vm = this;
      ENV.currentScene = vm.$route.params.scenedetail;
      if (vm.$route.params.photometric) {
        vm.fetchCatalogueData();
      }
      else {
        vm.fetchInteractiveData();
      }
    },
    created(){
      var vm = this;
      //var myHeaders = new Headers();
      //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));
      var url = document.querySelector('#root').getAttribute('data-endpoint-interactive-main');
      var listingUrl = document.querySelector('#root').getAttribute('data-endpoint-listing');
      var catalogueUrl = document.querySelector('#root').getAttribute('data-endpoint-catalogue');

      ENV.currentScene = vm.$route.params.scenedetail;

      this.$store.state.interface.isVisible = true;
      vm.$store.state.interface.isFooterVisible = true;

      //Check if cookie for tutorial is present
      function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      var hasCookie = getCookie('iguzzini-dle');
      if (hasCookie) {
        this.$store.state.hasTutorialPlayed = true;
        this.hideTutorial();
      }
      else {
        this.$store.state.hasTutorialPlayed = false;

        eventTracking.send({
          category: 'InteractiveTutorial',
          action: 'View'
        });

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SceneInteractive.vue